import { useCurrentRefinements } from 'react-instantsearch'
import { Button } from 'react-aria-components'

export default function AlgoliaFilterButton() {
  const { items } = useCurrentRefinements()

  // Calculate total number of active refinements
  const totalRefinements = items.reduce(
    (total, item) => total + item.refinements.length,
    0,
  )

  return (
    <Button
      className={`
        group
        flex
        shrink-0
        items-center
        justify-center
        h-[64px]
        max-sm:w-[54px]
        max-sm:h-[54px]
        gap-x-sm
        py-sm
        sm:px-lg
        text-lg
        rounded-full
        outline-2
        duration-250
        transition-colors
        outline-primary
        text-primary
        hover:text-bg
        hover:bg-primary
    `}>
      <svg width="24" height="24" className="text-current">
        <use xlinkHref="#icon-filters"></use>
      </svg>
      <span className="max-sm:sr-only whitespace-nowrap">
        Filters {totalRefinements >= 1 ? `(${totalRefinements})` : null}
      </span>
    </Button>
  )
}
